import { render, staticRenderFns } from "./Screen4.vue?vue&type=template&id=460505e8&"
import script from "./Screen4.vue?vue&type=script&lang=js&"
export * from "./Screen4.vue?vue&type=script&lang=js&"
import style0 from "./Screen4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports